export const MapConstants = {
  GOOGLE_SATILLITE_TILE_LAYER_URL: "http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}",
  GOOGLE_TILE_SUBDOMAIN_ARRAY: ["mt0", "mt1", "mt2", "mt3"],
  GOOGLE_MAP_ATTRIBUTION:
    '&copy; <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer">Google Maps</a>',
};
